import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import LinearProgress from 'Components/UI/LinearProgress';
import Uploader from 'Components/Files/MessageAttachments/Uploader';
import { getUploadText } from 'Helpers/File';
import { DataValueMap } from 'Helpers/Testing';
import {
  FDBox,
  FDSecondaryActionButton, FDSecondaryActionIconButton,
} from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('FileUploadButtonRebranded', (() => ({
  progressBar: {
    width: '55%',
    borderRadius: '50px',
  },
})));

function FileUploadButtonRebranded({
  attachmentCollection,
  onFailure,
  onStart,
  onSuccess,
  setUploadProgress,
  uploadProgress,
  disabled,
  buttonLabel,
  isIconButton,
  accept,
  test,
}) {
  const classes = useStyles();
  const isUploading = uploadProgress !== null;
  const disableButton = isUploading || disabled;
  const ProgressBarProps = {
    value: uploadProgress,
    variant: 'determinate',
    height: '32px',
  };

  return (
    <FDBox>
      {!isUploading && (
        <Uploader
          url={attachmentCollection?.link('self')?.url()}
          onStart={onStart}
          onSuccess={onSuccess}
          onCatch={onFailure}
          setUploadProgress={setUploadProgress}
          successToastMessage={null}
          disableClick={disableButton}
          accept={accept}
        >
          {(isIconButton) ? (
            <FDSecondaryActionIconButton
              label={buttonLabel}
              disabled={isUploading}
              size={'sm'}
              icon={'attachFile'}
              {...DataValueMap.init(test).build()}
            />
          ) : (
            <FDSecondaryActionButton
              label={buttonLabel}
              disabled={disableButton}
              icon={'attachFile'}
              size={'sm'}
              {...DataValueMap.init(test).build()}
            />
          )}
        </Uploader>)}
      <LinearProgress
        className={classNames(classes.progressBar)}
        visible={isUploading}
        text={getUploadText(uploadProgress)}
        ProgressProps={ProgressBarProps}
        useProgressForFDLOverlayClass
      />
    </FDBox>
  );
}

FileUploadButtonRebranded.defaultProps = {
  disabled: false,
  buttonLabel: 'Attach File',
  isIconButton: false,
  test: 'file-upload-button',
  accept: '',
};

FileUploadButtonRebranded.propTypes = {
  attachmentCollection: PropTypes.object.isRequired,
  onStart: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onFailure: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  buttonLabel: PropTypes.string,
  isIconButton: PropTypes.bool,
  accept: PropTypes.string,
  test: PropTypes.string,
};

export default FileUploadButtonRebranded;
